import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const seriesSlice = createAppSlice({
  name: 'series',
  initialState,
  reducers,
});

export const {
  loadSeriesListForChannel,
  loadSeriesFull,
  loadCurrentSeriesForProject,
  createSeries,
  addEventToSeries,
  deleteEventFromSeries,
  clearCurrentSeries,
  clearSeriesList,
  appendSeriesSync,
  openTopDrawer,
  closeTopDrawer,
  setSeriesEvents,
  setCurrentSeriesSync,
  updateSeries,
  resetSeriesReducer,
} = seriesSlice.actions;

export default seriesSlice.reducer;
